module.exports = __webpack_public_path__ + "img/small_rabbit.340e851e.gif";